import { render, staticRenderFns } from "./ManualChangeBadge.vue?vue&type=template&id=7f33c3b4&scoped=true"
import script from "./ManualChangeBadge.vue?vue&type=script&lang=js"
export * from "./ManualChangeBadge.vue?vue&type=script&lang=js"
import style0 from "./ManualChangeBadge.vue?vue&type=style&index=0&id=7f33c3b4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f33c3b4",
  null
  
)

export default component.exports